<div class="container mt-3 px-2">
  <div class="row">
    <div class="col-md-10 w-100 mt-4">
      <h4 class="title"><i class="fa fa-handshake"></i>  {{title | translate}}</h4>
    </div>
    <div class="col-md-2 mt-3">
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-2 custom-mr-24" *ngIf="hasRole(ROLE_SUPERADMIN)">
    <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-university"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="partnerSelected"
              (ngModelChange)="reloadEnterprises()">
        <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
    <label class="custom-label-1 font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-building"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="enterpriseSelected"
              (ngModelChange)="reloadWorkflows()">
        <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise">{{enterprise.name | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER) || hasRole(ROLE_ADMIN)">
    <label class="font-weight-bold">{{ "LABEL.FLOW" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-code-branch"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="workflowSelected"
              (ngModelChange)="search()">
        <option *ngFor="let workflow of workflows" [ngValue]="workflow">{{workflow.description | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24">
    <label for="dateFrom" class="font-weight-bold" data-toggle="tooltip"
           title="{{ 'MESSAGE.MAXIMUM-RANGE-IS-3-MONTHS' | translate }}">{{ "LABEL.FROM" | translate }}:</label>
    <div class="input-group w-custom-100">
      <input id="dateFrom" #dpFromDate
             class="form-control custom-label-1 {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
             name="dpFromDate"
             (dateSelect)="onDateSelectionFrom($event)"
             [value]="formatter.format(fromDate)"
             (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
             ngbDatepicker #d="ngbDatepicker"
             [markDisabled]="validatedDateFrom"
             [startDate]="fromDate"
             placeholder="dd/mm/yyyy" style="width: 150px;">
      <span class="custom-day"></span>
      <div class="input-group-append">
        <span class="btn btn-outline-success p-fixed {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
              (click)="d.toggle()" type="button">
          <i class="far fa-calendar-alt"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-2 custom-mr-24">
    <label for="dateTo"
           class="font-weight-bold" data-toggle="tooltip"
           title="{{ 'MESSAGE.THE-DATE-IS-CALCULATE-IN-THE-RANGE-3-MONTHS' | translate }}">
      {{ 'LABEL.TO' | translate }}:</label>
    <div class="input-group">
      <input id="dateTo" #dpToDate
             class="form-control custom-label-1 {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
             name="dpToDate"
             (dateSelect)="onDateSelectionTo($event)"
             [value]="formatter.format(toDate)"
             (input)="toDate = validateInput(toDate, dpToDate.value)"
             ngbDatepicker #d1="ngbDatepicker"
             [markDisabled]="validatedDateTo"
             placeholder="dd/mm/yyyy" style="width: 150px;">
      <div class="input-group-append">
        <span class="btn btn-outline-success p-fixed {{hasNotCorrectDateRange() ? 'border-color-red' : ''}}"
              (click)="d1.toggle()" type="button">
          <i class="far fa-calendar-alt"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-1 custom-mr-24 custom-mt-24">
    <button type="button"
            data-toggle="tooltip"
            title="{{ 'MESSAGE.MAXIMUM-RANGE-IS-3-MONTHS' | translate }}"
            class="btn btn-outline-success custom-button"
            [disabled]="hasNotCorrectDateRange()"
            (click)="search()"><i class="fa fa-search"></i> {{ 'BUTTON.SEARCH' | translate }}
    </button>
  </div>
  <div class="col-md-1 custom-mt-24">
    <button type="button" class="btn btn-dark dxbs-button custom-button"
            (click)="downloadReportOf()">
      <span aria-hidden="true" class="image far fa-file-excel"></span>
      {{ 'BUTTON.EXPORT' | translate }}
    </button>
  </div>
</div>
<div class="offset-md-4 text-primary">
  {{ "MESSAGE.MAXIMUM-RANGE-IS-3-MONTHS" | translate }}
</div>
<div class="bg-white-radius">
  <div class="widget-box widget-plain">
    <div class="center">
      <ul class="stat-boxes pl-5">
        <li class="card" *ngFor="let generalQuantity of generalQuantities">
          <div class="right">
            <app-consolidated-cards-report [generalQuantity]="generalQuantity"></app-consolidated-cards-report>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col" title="#"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.PARTNER' | translate }}" *ngIf="getVisibilityColumnPartner()"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"
            *ngIf="getVisibilityColumnEnterprise()"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.FLOW' | translate }}" *ngIf="getVisibilityColumnWorkflow()"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.GRAPHIC-S' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DIGITAL-S' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ONE-SIGN-S' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.REMOTE-S' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.REMOTE-WITH-TIMESTAMP-S' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.REMOTE-LTV-S' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.TIMESTAMP' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ELECT-NOTI' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.SENDING-CE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.NOTCER' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let consolidatedSignature of consolidatedSignatures; let index=index"
          class="{{hasRole(ROLE_PARTNER)?'custom-font-size-table-body':'custom-font-size-table-body-isnt-partner'}}">
        <td title="#">{{(page.number * 10) + index + 1}}</td>
        <td title="{{ 'TABLE.HEADER.PARTNER' | translate }}"
            *ngIf="getVisibilityColumnPartner()">{{consolidatedSignature.partnerName}}</td>
        <td title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"
            *ngIf="getVisibilityColumnEnterprise()">{{consolidatedSignature.enterpriseName}}</td>
        <td title="{{ 'TABLE.HEADER.FLOW' | translate }}"
            *ngIf="getVisibilityColumnWorkflow()">{{consolidatedSignature.workflowName}}</td>
        <td title="{{ 'TABLE.HEADER.GRAPHIC-S' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityGraphicSignature)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityGraphicSignature)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityGraphicSignature}}"
                (click)="viewDetail(consolidatedSignature, ELECTRONIC_SIGNATURE)">{{consolidatedSignature.quantityGraphicSignature}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.DIGITAL-S' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityDigitalSignature)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityDigitalSignature)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityDigitalSignature}}"
                (click)="viewDetail(consolidatedSignature, DIGITAL_SIGNATURE)">{{consolidatedSignature.quantityDigitalSignature}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.ONE-SIGN-S' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityOneSignSignature)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityOneSignSignature)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityOneSignSignature}}"
                (click)="viewDetail(consolidatedSignature, CLOUD_SIGNATURE)">{{consolidatedSignature.quantityOneSignSignature}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.REMOTE-S' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityRemoteSignature)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityRemoteSignature)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityRemoteSignature}}"
                (click)="viewDetail(consolidatedSignature, REMOTE_SIGNATURE)">{{consolidatedSignature.quantityRemoteSignature}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.REMOTE-WITH-TIMESTAMP-S' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityRemoteSignatureWithTimeStamp)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityRemoteSignatureWithTimeStamp)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityRemoteSignatureWithTimeStamp}}"
                (click)="viewDetail(consolidatedSignature, REMOTE_SIGNATURE_WITH_TIMESTAMP)">{{consolidatedSignature.quantityRemoteSignatureWithTimeStamp}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.REMOTE-LTV-S' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityRemoteSignatureWithLTV)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityRemoteSignatureWithLTV)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityRemoteSignatureWithLTV}}"
                (click)="viewDetail(consolidatedSignature, REMOTE_SIGNATURE_WITH_LTV)">{{consolidatedSignature.quantityRemoteSignatureWithLTV}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.TIMESTAMP' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityTimeStamp)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityTimeStamp)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityTimeStamp}}"
                (click)="viewDetail(consolidatedSignature, TIMESTAMP)">{{consolidatedSignature.quantityTimeStamp}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.ELECT-NOTI' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantitySendElectronicNotification)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantitySendElectronicNotification)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantitySendElectronicNotification}}"
                (click)="viewDetail(consolidatedSignature, SEND_ELECTRONIC_NOTIFICATION)">{{consolidatedSignature.quantitySendElectronicNotification}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.SENDING-CE' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantitySendEmail)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantitySendEmail)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantitySendEmail}}"
                (click)="viewDetail(consolidatedSignature, SEND_EMAIL)">{{consolidatedSignature.quantitySendEmail}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.NOTCER' | translate }}"><a
          *ngIf="!hasMoreThanZero(consolidatedSignature.quantityNotcer)">-</a>
          <span *ngIf="hasMoreThanZero(consolidatedSignature.quantityNotcer)"
                class="badge badge-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title="{{consolidatedSignature.quantityNotcer}}"
                (click)="viewDetail(consolidatedSignature, NOTCER)">{{consolidatedSignature.quantityNotcer}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <label class="mr-1 font-weight-normal">Mostrar </label>
          <select class="mr-1 br-6 form-select-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="loadConsolidatedServices(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <label class="font-weight-normal"> registros.</label>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{consolidatedSignatures.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadConsolidatedServices(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left {{page.number == 0 ? 'disabled' : ''}}"
               (click)="loadConsolidatedServices(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadConsolidatedServices(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="next" (click)="loadConsolidatedServices(enumPage.Last)">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="(loading && !calledOfAutorefresh) || loadingShowBy"></app-loading>
